import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldOff, ChevronLeft } from "lucide-react";
import { useServiceFlags } from "@/contexts/ServiceFlagsContext";
import Layout from "@/components/Layout";
import BottomNav from "@/components/BottomNav";

/**
 * ServiceGate wraps a service route.
 * If the service key is disabled in admin, renders a Service Unavailable screen.
 */
export default function ServiceGate({ serviceKey, children }) {
  const { flags, isEnabled } = useServiceFlags();
  const navigate = useNavigate();

  // flags === {} means not yet loaded — default to showing the service
  const flagsLoaded = Object.keys(flags).length > 0;
  if (!flagsLoaded || isEnabled(serviceKey)) {
    return children;
  }

  return (
    <Layout title="Service Unavailable" hideHeader>
      <div className="min-h-screen bg-[#F5F7FB] flex flex-col pb-24">
        {/* Header */}
        <div className="bg-white border-b border-slate-100 px-4 pt-10 pb-4 flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 rounded-xl bg-slate-50 border border-slate-200 flex items-center justify-center"
            data-testid="service-gate-back-btn"
          >
            <ChevronLeft size={18} className="text-slate-700" />
          </button>
          <h1 className="text-slate-900 font-extrabold text-lg">Service Unavailable</h1>
        </div>

        {/* Content */}
        <div className="flex-1 flex flex-col items-center justify-center px-6 text-center gap-5">
          <div className="w-20 h-20 rounded-3xl bg-red-50 border border-red-100 flex items-center justify-center">
            <ShieldOff size={36} className="text-red-400" />
          </div>

          <div>
            <h2 className="text-slate-900 font-extrabold text-xl">Access Denied</h2>
            <p className="text-slate-500 text-sm mt-2 max-w-xs leading-relaxed">
              This service has been temporarily disabled by the administrator.
              Please check back later or contact support.
            </p>
          </div>

          <button
            onClick={() => navigate("/appmobile/dashboard")}
            className="bg-[#064BCB] text-white font-bold px-8 py-3.5 rounded-2xl text-sm hover:bg-[#0437A0] transition-all"
            data-testid="service-gate-home-btn"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
      <BottomNav />
    </Layout>
  );
}
